"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  LIGHT: {
    MAIN: {
      PRIMARY: '#056cf2',
      SECONDARY: '#020126',
      SUCCESS: '#14c458',
      ERROR: '#f73e55',
      WARNING: '#ffd500',
      INFO: '#0184F7'
    },
    NEUTRAL: {
      BACKGROUND: '#ffffff',
      CARD: '#ffffff',
      SIDE: '#F3F3F3',
      SELECTED: '#E0E0E0',
      TRANSPARENT: 'transparent'
    },
    FONT: {
      TITLE: '#1e1926',
      DESCRIPTION: '#8a8a8a',
      HELPER: '#696974',
      CONTRAST: '#ffffff'
    }
  },
  DARK: {
    MAIN: {},
    NEUTRAL: {
      BACKGROUND: '#101013',
      CARD: '#22222a',
      SIDE: '#17171c',
      SELECTED: '#0c0b10',
      TRANSPARENT: 'transparent'
    },
    FONT: {
      TITLE: '#F3F3F3',
      DESCRIPTION: '#333333',
      HELPER: '#6B6B6C'
    }
  }
};